/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : customerSlice.ts
 *
 * Project Title : RDR7000
 *
 * Description   : Redux Slice for Customer state
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : Aug 12, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : Aug 12, 2020
 * Description   : Add code to maintain state for customer related data
 *
 *
 ******************************************************************************/

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICustomerState, ICustomer, IAgentCustomer } from 'models/customer';
import { AppThunk, RootState } from 'stores/GlobalStore';
import { apiCallBegan } from 'stores/middlewares';

export const initialState: ICustomerState = {
  customerList: null,
  selectedCustomer: null,
  agentModal: {
    customerList: null,
    agentCustomerLoader: false
  }
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomerList(customerState: ICustomerState, action: PayloadAction<ICustomer[]>) {
      customerState.customerList = action.payload;
    },
    resetCustomerList(customerState: ICustomerState) {
      customerState.customerList = [];
    },
    setSelectedCustomer(customerState: ICustomerState, action: PayloadAction<ICustomer | null>) {
      customerState.selectedCustomer = action.payload;
    },
    setAgentCustomerList(customerState: ICustomerState, action: PayloadAction<IAgentCustomer[]>) {
      customerState.agentModal.customerList = action.payload;
      customerState.agentModal.agentCustomerLoader = false;
    },
    startAgentCustomerLoader(customerState: ICustomerState) {
      customerState.agentModal.agentCustomerLoader = true;
    },
    resetAgentCustomerList(customerState: ICustomerState) {
      customerState.agentModal.customerList = [];
    },
  },
});

export const { setSelectedCustomer, startAgentCustomerLoader } = customerSlice.actions;
const { setCustomerList, resetCustomerList, setAgentCustomerList, resetAgentCustomerList } = customerSlice.actions;

export const customerReducer = customerSlice.reducer;

export const fetchCustomers = (): AppThunk => async dispatch => {
  const url = '/customer';

  dispatch(
    apiCallBegan({
      url,
      onSuccess: setCustomerList.type,
      onError: resetCustomerList.type,
      showGlobalError: true,
    })
  );
};

export const fetchAllCustomers = (customerName: string): AppThunk => async dispatch => {
  const url = `/all-account/${customerName}`;

  dispatch(
    apiCallBegan({
      url,
      onStart: startAgentCustomerLoader.type,
      onSuccess: setAgentCustomerList.type,
      onError: resetAgentCustomerList.type,
      showGlobalError: true,
    })
  );
};

export const selectCustomerList = (state: RootState) => state.customer.customerList;
export const selectCustomer = (state: RootState) => state.customer.selectedCustomer;
export const selectAgentModal = (state: RootState) => state.customer.agentModal;
